import { render, staticRenderFns } from "./setModal.vue?vue&type=template&id=003ce1a3&scoped=true&"
import script from "./setModal.vue?vue&type=script&lang=js&"
export * from "./setModal.vue?vue&type=script&lang=js&"
import style0 from "./setModal.vue?vue&type=style&index=0&id=003ce1a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003ce1a3",
  null
  
)

export default component.exports